export const currencies = [
  { code: 'USD', symbol: '$', nameKey: 'currency_usd' },
  { code: 'AUD', symbol: 'AU$', nameKey: 'currency_aud' },
  { code: 'EUR', symbol: '€', nameKey: 'currency_eur' },
  { code: 'CAD', symbol: 'CA$', nameKey: 'currency_cad' },
  { code: 'CHF', symbol: 'CHF', nameKey: 'currency_chf' },
  { code: 'CNY', symbol: 'CN¥', nameKey: 'currency_cny' },
  { code: 'GBP', symbol: '£', nameKey: 'currency_gbp' },
  { code: 'JPY', symbol: '¥', nameKey: 'currency_jpy' },
  { code: 'KRW', symbol: 'KRW', nameKey: 'currency_krw' },
  { code: 'SEK', symbol: 'SEK', nameKey: 'currency_sek' },
  { code: 'SGD', symbol: 'SGD', nameKey: 'currency_sgd' },
  { code: 'TRY', symbol: '₺', nameKey: 'currency_try' },


];